import { css } from "@styled-system/css";
import { keyframes } from "emotion";

import { theme } from "@skin/v2";

const loading = keyframes`
  
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
`;

export const styles = {
  root: css({
    animation: `${loading} 4s infinite`,
    background: `linear-gradient(to right, #ffffff, ${theme.colors.pink[500]})`,
    height: "1px",
    width: "100%",
  }),
};
